import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS].GET_REGULATIONS_STAGES_PLAN_WORKS]: {
		url:'/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS].GET_REGULATIONS_STAGES_PLAN_WORK_PREVIEW]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/preview/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS].GET_REGULATIONS_STAGES_PLAN_WORK_POPUP]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/popup/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS].GET_REGULATIONS_STAGES_PLAN_WORK_EXTENDED_POPUP]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/extended_popup/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS].GET_REGULATIONS_STAGES_PLAN_WORK]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS].GET_REGULATIONS_STAGES_PLAN_WORK_DONE_WORKS]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/done_works/',
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS].CREATE_REGULATIONS_STAGES_PLAN_WORK]: {
		url:'/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS].PATCH_REGULATIONS_STAGES_PLAN_WORK]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS].PUT_REGULATIONS_STAGES_PLAN_WORK]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS].DELETE_REGULATIONS_STAGES_PLAN_WORK]: {
		url: '/company/:companyId/regulations/:regulationId/stages/:stageId/plan_works/:planWorkId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}
